/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromSubmitHiglightForm from 'app/library/store/actions/submit-highlight-form.action';

export interface SubmitHighlightFormState {
  userData: any;
  draftData: any;
  errorMessage: string;
  success: boolean;
  loading: boolean;
}

export const initialState = {
  userData: null,
  draftData: null,
  errorMessage: null,
  success: false,
  loading: false,
};

export function reducer(
  state = initialState,
  action: fromSubmitHiglightForm.SubmitHighlightFormAction
): SubmitHighlightFormState {
  switch (action.type) {
    case fromSubmitHiglightForm.SUBMIT_HIGHLIGHT_FORM: {
      return {
        ...state,
        userData: null,
        draftData: null,
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromSubmitHiglightForm.SUBMIT_HIGHLIGHT_FORM_FAIL: {
      return {
        ...state,
        userData: null,
        draftData: null,
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromSubmitHiglightForm.SUBMIT_HIGHLIGHT_FORM_SUCCESS: {
      return {
        ...state,
        userData: action.payload,
        draftData: null,
        errorMessage: null,
        loading: false,
        success: true,
      };
    }

    case fromSubmitHiglightForm.RESET_HIGHLIGHT_REEL_FORM: {
      return {
        ...initialState,
      };
    }

    case fromSubmitHiglightForm.SET_DRAFT_FORM_DATA: {
      return {
        ...initialState,
        draftData: action.payload,
      };
    }
  }

  return state;
}

export const submitHighlightFormData = (state: SubmitHighlightFormState) => state.userData;
export const submitHighlightDraftData = (state: SubmitHighlightFormState) => state.draftData;
export const submitHighlightFormErrorMessage = (state: SubmitHighlightFormState) => state.errorMessage;
export const submitHighlightFormLoading = (state: SubmitHighlightFormState) => state.loading;
export const submitHighlightFormSuccess = (state: SubmitHighlightFormState) => state.success;
